// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__0_l_H","wrapperOpened":"styles_wrapperOpened__mvtw_","wrapperForUser":"styles_wrapperForUser___16Cp"};
module.exports.__checksum = "9ae8dc9e0db4"